import type { ReactNode } from 'react';
import { CloseIcon } from '@/components/ui/Icons';
import './PopoverHeaderClose.css';

export interface EditableCellPopoverHeaderProps {
  children: ReactNode;
  onClose: () => void;
}

export function EditableCellPopoverHeader({ children, onClose }: EditableCellPopoverHeaderProps) {
  return (
    <div className="editable-cell-popover__header editable-cell-popover__header-row">
      <div className="editable-cell-popover__header-title">{children}</div>
      <button
        type="button"
        className="popover-header-close-btn"
        onClick={(e) => {
          e.stopPropagation();
          onClose();
        }}
        aria-label="Закрыть"
        title="Закрыть"
      >
        <CloseIcon size={16} />
      </button>
    </div>
  );
}
